
import { createTranslations } from '../../../i18n/types';

export default createTranslations({
  en: {
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    refundPolicy: 'Refund Policy',
    paymentOrder: 'Payment Procedure',
    howItWorks: 'How the service works',
    contacts: 'Contacts',
    support: 'Support',
    refundTerms: 'Refund terms',
    digitalContent: 'Digital content',
    wiki: 'CS2 skin wiki',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
  ru: {
    userAgreement: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
    refundPolicy: 'Политика возвратов',
    paymentOrder: 'Порядок оплаты',
    howItWorks: 'Как работает сервис',
    contacts: 'Контакты',
    support: 'Поддержка',
    refundTerms: 'Условия возврата',
    digitalContent: 'Получение цифрового контента',
    wiki: 'Вики скинов CS2',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
  uz: {
    userAgreement: 'Foydalanuvchi shartnomasi',
    privacyPolicy: 'Maxfiylik siyosati',
    refundPolicy: 'Qaytarish siyosati',
    paymentOrder: 'Toʻlov tartibi',
    howItWorks: 'Xizmat qanday ishlaydi',
    contacts: 'Kontaktlar',
    support: 'Qoʻllab-quvvatlash',
    refundTerms: 'Qaytarish shartlari',
    digitalContent: 'Raqamli kontent olish',
    wiki: 'CS2 skinlari vikisi',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
  fa: {
    userAgreement: 'شرایط استفاده',
    privacyPolicy: 'سیاست حریم خصوصی',
    refundPolicy: 'سیاست بازگشت وجه',
    paymentOrder: 'روال پرداخت',
    howItWorks: 'سرویس چطور کار می‌کند',
    contacts: 'تماس',
    support: 'پشتیبانی',
    refundTerms: 'شرایط بازگشت وجه',
    digitalContent: 'محتوای دیجیتال',
    wiki: 'ویکی اسکین‌های CS2',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
  pt: {
    userAgreement: 'Termos de uso',
    privacyPolicy: 'Política de privacidade',
    refundPolicy: 'Política de reembolso',
    paymentOrder: 'Procedimento de pagamento',
    howItWorks: 'Como o serviço funciona',
    contacts: 'Contatos',
    support: 'Suporte',
    refundTerms: 'Condições de reembolso',
    digitalContent: 'Entrega de conteúdo digital',
    wiki: 'Wiki de skins do CS2',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
  tr: {
    userAgreement: 'Kullanıcı sözleşmesi',
    privacyPolicy: 'Gizlilik politikası',
    refundPolicy: 'İade politikası',
    paymentOrder: 'Ödeme prosedürü',
    howItWorks: 'Hizmet nasıl çalışır',
    contacts: 'İletişim',
    support: 'Destek',
    refundTerms: 'İade koşulları',
    digitalContent: 'Dijital içeriğin teslimi',
    wiki: 'CS2 Skin Vikisi',
    companyInfo: 'Magic Lucky Corporation\n2024-001445331\n312 W 2nd St, Ste 6031, Casper, WY 82601, USA',
  },
});
